<template>
  <div
    class="customise-item"
    style="display: block"
    :style="getAddToCardRolldStyle()"
    ref="customiseItem"
  >
    <div class="customise-item-details">
      <div
        class="extra-items-wrapper"
        :class="{ rollinto: toggleRollInto, 'ios-scroll': !toggleRollInto }"
      >
        <div
          v-if="!toggleRollInto"
          ref="headerImg"
          :style="getImageStyle()"
          class="modalImage w-100"
        />
        <img
          v-if="!toggleRollInto"
          v-show="false"
          :src="getProductImage(product)"
          @error="imgHttpError"
          alt="productImage"
        />
        <div
          class="container item-details"
          :class="{ 'ios-scroll': toggleRollInto }"
          :style="getModifiersContainerStyle()"
        >
          <div class="row" v-if="!toggleRollInto">
            <div class="col-12">
              <h3 class="text-center">{{ getProductName() }}</h3>
              <p
                class="s-description text-center"
                :style="getDescriptionStyle()"
                v-html="getProductDescription()"
              ></p>
            </div>
            <div class="w-100 pt-2 text-center">
              <!--              <h3>{{ price | formatMoney(currencySign) }}</h3>-->
              <template v-if="!priceOverride">
                {{ price | formatMoney(currencySign) }}
              </template>
              <template v-else>
                <del>{{ price | formatMoney(currencySign) }}</del>
                <span class="ml-2">{{
                  priceOverride | formatMoney(currencySign)
                }}</span>
              </template>

              <h3
                v-if="getBasePoints"
                class="ml-2"
                :class="showNewUi ? 'text-dark' : 'text-success'"
              >
                ({{ Math.floor(getBasePoints) | formatNumber }} pts)
              </h3>
            </div>
            <div
              v-if="!isDigitalDisplay"
              class="w-100 mt-3 pb-1 d-flex justify-content-center"
            >
              <button
                :disabled="quantity <= 1 || cartQuantity > maxItemQuantity"
                class="btn-white btn-circle d-flex justify-content-center align-items-center"
                :style="mobileStyles.CommonColorTxt"
                @click="dec"
              >
                <span class="material-icons bigger-material-icons px-2"
                  >remove_circle_outline</span
                >
              </button>
              <span class="d-flex px-3 align-items-center">
                <strong v-if="cartQuantity > maxItemQuantity">1</strong>
                <strong v-else>{{ quantity }}</strong>
              </span>
              <button
                :disabled="cartQuantity >= maxItemQuantity"
                class="btn-white btn-circle d-flex justify-content-center align-items-center"
                :style="mobileStyles.CommonColorTxt"
                @click="inc"
              >
                <span class="material-icons bigger-material-icons"
                  >add_circle_outline</span
                >
              </button>
            </div>
          </div>
          <div v-show="!toggleRollInto" class="mt-3">
            <Modifiers
              @showSubmodifier="customizeSubmodifier"
              :product="product"
              :modifiers="modifiers"
              :is-submodifier="toggleRollInto"
              :modifier-groups-states="ModifierGroupsStates"
              ref="modifiersRefs"
            />
            <UpsellProducts
              :category="parentCategory"
              @onvalue="onUpsellValue"
            />
            <div v-if="showRollIntoProduct" class="container mb-2">
              <div class="row">
                <a
                  v-if="selectedRollIntoModiefiers.length == 0"
                  :style="rollIntoButtonClassNames(selectedRollIntoModiefiers)"
                  @click="enableRollInto()"
                >
                  <div class="roll-into-items">
                    <div class="roll-item-details">
                      <div class="roll-item-details-name">
                        {{ showRollIntoProduct.Name }}
                      </div>
                    </div>
                    <div
                      v-if="getRollIntoPoints"
                      class="roll-item-point-addtocart"
                    >
                      ({{ Math.floor(getRollIntoPoints) | formatNumber }} pts)
                    </div>
                    <div
                      :class="getRollIntoPoints ? 'has-point' : ''"
                      class="roll-item-cost"
                    >
                      {{
                        showRollIntoProduct.FixedPriceValue
                          | formatMoney(currencySign)
                      }}
                    </div>
                  </div>
                </a>
                <a v-else class="w-100" @click="enableRollInto">
                  <div
                    v-if="selectedRollIntoModiefiers.length > 0"
                    :style="
                      rollIntoButtonClassNames(selectedRollIntoModiefiers)
                    "
                    class="h-100"
                  >
                    <div class="roll-into-items">
                      <div class="roll-item-details">
                        <div class="roll-item-details-name">
                          {{ showRollIntoProduct.Name }}
                        </div>
                        <ul>
                          <li
                            v-for="md in selectedRollIntoModiefiers"
                            :key="md.ID"
                          >
                            {{ md.Name }} ({{ md.quantity }})
                          </li>
                        </ul>
                      </div>
                      <div
                        v-if="getRollIntoPoints"
                        class="roll-item-point-addtocart selected"
                      >
                        ({{ Math.floor(getRollIntoPoints) | formatNumber }} pts)
                      </div>
                      <div
                        :class="getRollIntoPoints ? 'has-point' : ''"
                        class="roll-item-cost"
                      >
                        {{ rollIntoPrice | formatMoney(currencySign) }}
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div class="w-100 mb-2" v-show="viewConfig.ShowNotesForItem">
              <div>
                <h4>{{ $t("message.notes") }}</h4>
                <textarea
                  id="notes"
                  maxlength="300"
                  v-model="itemNote"
                  name="notes"
                  type="text"
                  class="form-control"
                  :class="{ 'rolld-textarea': isRolldStore() }"
                />
              </div>
            </div>
          </div>
          <div v-show="toggleRollInto">
            <Modifiers
              v-if="toggleRollInto"
              :price-trigger="showRollIntoProduct"
              @canceled="cancelSubModifier"
              :product="rollIntoParams.product"
              :modifiers="rollIntoParams.modifiers"
              :product-id="rollIntoParams.productId"
              @updated="selectRollIntoModiefiers"
              :is-submodifier="toggleRollInto"
              :initial-modifiers="rollIntoParams.initModifiers"
              :has-confirm-button="true"
              :selected-modifier="rollIntoParams.selectedModifier"
            />
          </div>
        </div>
      </div>
      <footer class="extras-footer" v-if="!toggleRollInto">
        <div class="cart-btn-group">
          <button
            type="button"
            class="btn"
            :class="[isDigitalDisplay ? 'w-100' : '', 'btn-cancel']"
            :style="getCancelButtonStyle()"
            @click="closeModalMobile()"
          >
            {{ $t("message.cancel") }}
          </button>
          <button
            type="button"
            class="btn btn-primary"
            v-if="!isDigitalDisplay"
            :style="getConfirmButtonStyle()"
            :disabled="isDisabledAddCards"
            @click="addToCartMobile()"
          >
            <span v-if="cartQuantity <= maxItemQuantity" style="float: left">
              {{ $t("message.addToCart") }}
            </span>
            <span
              v-if="cartQuantity <= maxItemQuantity"
              style="float: right; margin-right: 2px"
              >{{ totalPrice | formatMoney(currencySign) }}</span
            >
            <span v-else style="float: right">
              {{ $t("message.maximumQuantityExceeded") }}
            </span>
          </button>
        </div>
      </footer>
    </div>
    <paylater-alert :type="4" v-if="showDuplicateItemsAlert"></paylater-alert>
  </div>
</template>

<script>
import shared from "../../../sharedscripts/shop/products/AddToCart.js";
import sharedProduct from "../../../sharedscripts/shop/products/Product";
import sharedTranslations from "../../../sharedscripts/shop/products/Translations";
import Modifiers from "./Modifiers";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { scrollModify } from "../../../api/helpers/uiHelper";
import UpsellProducts from "./UpsellProducts.vue";
import paylaterAlert from "../../shared/paylaterAlert.vue";

export default {
  name: "AddToCartMobile",
  components: { Modifiers, UpsellProducts, paylaterAlert },
  props: {
    category: {
      type: Object,
      default: () => {},
    },
    parentCategory: {
      type: Object,
      default: () => {},
    },
    product: {
      type: Object,
      default: () => {},
    },
    modifiers: {
      type: Object,
      default: () => {},
    },
    price: {
      type: Number,
      default: 0,
    },
    productId: {
      type: Number,
      default: 0,
    },
    imageStyles: {
      type: Array,
      default: () => [],
    },
  },
  // watch: {
  //   // ModifierGroupsStates: {
  //   //   handler: function() {
  //   //     this.checkMaximumSelection();
  //   //     this.checkMinimumSelection();
  //   //   },
  //   //   deep: true
  //   // }
  // },
  data() {
    return {
      quantity: 1,
      maxItemQuantity: 20,
      selectedModifiers: [],
      ModifierGroupsStates: [],
      toggleRollInto: false,
      selectedRollIntoModiefiers: [],
      itemNote: "",
      selectedModifierForCustomize: null,
      forceUpdate: false,
      showDuplicateItemsAlert: false,
      upsellProducts: [],
    };
  },
  mounted() {
    scrollModify(true);
    this.checkSharedCartDuplicateItems();
    if (this.showNewUi) {
      this.toggleAddToCartOpen(true);
    }

    // temp solution to force focus the modal
    setTimeout(() => {
      this.$refs.customiseItem.click()
    }, 70);


  },
  destroyed() {
    if (this.showNewUi) {
      setTimeout(() => {
        this.toggleAddToCartOpen(false);

      }, 50);
    }
  },

  computed: {
    ...mapGetters([
      "viewConfig",
      "mobileStyles",
      "canshowRollInto",
      "storeMenu",
      "isDigitalDisplay",
    ]),
    ...shared.computed,
    ...sharedProduct.computed,
    showRollIntoProduct() {
      return this.canshowRollInto(
        { ...this.product, quantity: this.quantity },
        this.quantity
      );
    },
    menuCopy() {
      return JSON.parse(JSON.stringify(this.storeMenu));
    },

    rollIntoPrice() {
      var result = 0;
      this.selectedRollIntoModiefiers.forEach((element) => {
        result += element.Price;
      });
      return this.showRollIntoProduct
        ? this.showRollIntoProduct.FixedPriceValue
        : 0 + result;
    },
    showNewUi() {
      return this.viewConfig.IsNewUi;
    },
  },
  methods: {
    ...mapMutations(["confirmRollInto"]),
    ...mapActions(["toggleAddToCartOpen"]),
    ...shared.methods,
    ...sharedTranslations.methods,
    getStyle(isChecked) {
      var style = [];
      if (isChecked) {
        style.push(this.mobileStyles.CommonColorBackground);
      } else {
        style.push({
          "background-color": `rgb(255, 255, 255) !important`,
        });
      }
      return style;
    },
    getModifiersContainerStyle() {
      var style = [];
      if (this.toggleRollInto) {
        style.push({ height: "calc(100vh - 175px)" });
        style.push({ "overflow-y": "auto" });
        style.push({ "margin-bottom": "50px" });
      }
      if (
        !this.productImageExistsNewUi &&
        this.showNewUi &&
        !this.toggleRollInto
      ) {
        style.push({ "margin-top": "-25vh" });
      }
      return style;
    },
    cancelSubModifier() {
      this.toggleRollInto = false;
      scrollModify(true);
    },
    enableRollInto() {
      this.toggleRollInto = true;
      scrollModify(true);
    },
    getAddToCardRolldStyle() {
      var styles = [];
      if (this.isRolldStore()) {
        styles.push(this.mobileStyles.primaryBodyBackground);
      }
      return styles;
    },

    getDescriptionStyle() {
      var styles = [];
      if (this.showNewUi) {
        styles.push({ "font-size": "0.8rem !important" });
      }
      return styles;
    },
    getCancelButtonStyle() {
      var styles = [];
      styles.push(this.mobileStyles.btn);
      if (this.showNewUi) {
        styles.push({ opacity: "0.85" });
      }
      return styles;
    },

    getConfirmButtonStyle() {
      var styles = [];

      styles.push(this.mobileStyles.btn);
      return styles;
    },
  },
};
</script>
